import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/login/Login";
import Signup from "../pages/Signup/Signup";
import NotFound from "../pages/NotFound/NotFound";
import ProtectedRoute from "./ProtectedRoute";
import Loader from "../components/Loader";

const CreateAccount = lazy(() => import("../components/CreateAccount/CreateAccount"));
const LearnerManagement = lazy(() => import("../pages/LearnerManagement/LearnerManagement"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword/ForgotPassword"));
const OtpVerification = lazy(() => import("../pages/OtpVerification/OtpVerification"));
const ResetPassword = lazy(() => import("../pages/ResetPassword/ResetPassword"));
const LearnersTable = lazy(() => import("../components/LearnersTable/LearnersTable"));
const DashboardTable = lazy(() => import("../components/DashboardTable/DashboardTable"));
const LearnerCardTwo = lazy(() => import("../components/LearnerCardTwo/LearnerCardTwo"));
const AddLearner = lazy(() => import("../pages/AddLearner/AddLearner"));
const IssueBagesTable = lazy(() => import("../pages/IssueBagesTable/IssueBagesTable"));
const ContactSupport = lazy(() => import("../pages/ContactSupport/ContactSupport"));
const LearnersProfile = lazy(() => import("../pages/LearnersProfile/LearnersProfile"));
const UpdateLearnerProfile = lazy(() => import("../pages/UpdateLearnerProfile/UpdateLearnerProfile"));
const AccessManagement = lazy(() => import("../pages/AccessManagement/AccessManagement"));
const AddStaff = lazy(() => import("../pages/AccessManagement/AddStaff/AddStaff"));
const EditStaff = lazy(() => import("../pages/AccessManagement/EditStaff/EditStaff"));
const CredentialFactory = lazy(() => import("../pages/CredentialFactory/CredentialFactory"));
const IssueCredential = lazy(() => import("../pages/CredentialFactory/IssueCredential/IssueCredential"));
const BadgesIssueTable = lazy(() => import("../components/BadgesIssueTable/BadgesIssueTable"));
const PendingApproval = lazy(() => import("../pages/CredentialFactory/CredentialCardRecent/PendingApproval/PendingApproval"));
const CreateBadge = lazy(() => import("../pages/CredentialFactory/CreateBadge/CreateBadge"));
const EditBadge = lazy(() => import("../pages/CredentialFactory/EditBadge/EditBadge"));
const CredentialLearnersIssue = lazy(() => import("../pages/CredentialFactory/CredentialTable/CredentialLearnersIssue/CredentialLearnersIssue"));
const EditGeneralInformation = lazy(() => import("../pages/CredentialFactory/EditBadge/EditGeneralInformation/EditGeneralInformation"));
const EditPreview = lazy(() => import("../pages/CredentialFactory/EditBadge/EditPreview/EditPreview"));
const Preview = lazy(() => import("../pages/CredentialFactory/CreateBadge/Preview/Preview"));
const Settings = lazy(() => import("../pages/CredentialFactory/CreateBadge/Settings/Settings"));
const ChangePassword = lazy(() => import("../pages/ChangePassword/ChangePassword"));
const DeletedUsers = lazy(() => import("../pages/DeletedUsers/DeletedUsers"));
const LoginContactSupport = lazy(() => import("../pages/LoginContactSupport/LoginContactSupport"));

const RouterComponent = () => {
  return (
    <Router>
      <Suspense fallback={ <div className="loader-container">
                  <Loader />
                </div>}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/createaccount" element={<CreateAccount />} />
          <Route path="/learnermanagement" element={<ProtectedRoute><LearnerManagement /></ProtectedRoute>} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/otpverification" element={<OtpVerification />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/learnerstable" element={<ProtectedRoute><LearnersTable /></ProtectedRoute>} />
          <Route path="/dashboardtable" element={<ProtectedRoute><DashboardTable /></ProtectedRoute>} />
          <Route path="/learnercard" element={<ProtectedRoute><LearnerCardTwo /></ProtectedRoute>} />
          <Route path="/addlearner" element={<ProtectedRoute><AddLearner /></ProtectedRoute>} />
          <Route path="/issuebagestable" element={<ProtectedRoute><IssueBagesTable /></ProtectedRoute>} />
          <Route path="/contactsupport" element={<ProtectedRoute><ContactSupport /></ProtectedRoute>} />
          <Route path="/logincontactsupport" element={<LoginContactSupport />} />
          <Route path="/learnersprofile/:id" element={<ProtectedRoute><LearnersProfile /></ProtectedRoute>} />
          <Route path="/updatelearnerprofile/:id" element={<ProtectedRoute><UpdateLearnerProfile /></ProtectedRoute>} />
          <Route path="/accessmanagement" element={<ProtectedRoute><AccessManagement /></ProtectedRoute>} />
          <Route path="/support" element={<ProtectedRoute><UpdateLearnerProfile /></ProtectedRoute>} />
          <Route path="/addstaff" element={<ProtectedRoute><AddStaff /></ProtectedRoute>} />
          <Route path="/editstaff/:id" element={<ProtectedRoute><EditStaff /></ProtectedRoute>} />
          <Route path="/credentialfactory" element={<ProtectedRoute><CredentialFactory /></ProtectedRoute>} />
          <Route path="/issuecredential" element={<ProtectedRoute><IssueCredential /></ProtectedRoute>} />
          <Route path="/badgesissuetable" element={<ProtectedRoute><BadgesIssueTable /></ProtectedRoute>} />
          <Route path="/pendingapproval" element={<ProtectedRoute><PendingApproval /></ProtectedRoute>} />
          <Route path="/createbadge" element={<ProtectedRoute><CreateBadge /></ProtectedRoute>} />
          <Route path="/editbadge/:id" element={<ProtectedRoute><EditBadge /></ProtectedRoute>} />
          <Route path="/credlearnersissue" element={<ProtectedRoute><CredentialLearnersIssue /></ProtectedRoute>} />
          <Route path="/editgeneralinformation" element={<ProtectedRoute><EditGeneralInformation /></ProtectedRoute>} />
          <Route path="/editpreview" element={<ProtectedRoute><EditPreview /></ProtectedRoute>} />
          <Route path="/preview" element={<ProtectedRoute><Preview /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/changepassword" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          <Route path="/deletedusers" element={<ProtectedRoute><DeletedUsers /></ProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default RouterComponent;
